import "./Contacts.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import contactsLinks from "./ContactsData";

const Contacts = () => {
  return (
    <div className="contact">
      <ul className="contact__list">
        {contactsLinks.map((l) => (
          <li key={l.href} className="contact__item">
            <a href={l.href} className="contact__link" aria-label={l.label} target="_blank" rel="noopener noreferrer">
              <FontAwesomeIcon icon={l.icon} className="contact__link-icon" />
              <span className="contact__link-text">{l.label}</span>
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default Contacts;